import React from 'react';
import Navbar from './Navbar';
import '../styles.css';

function PrivacyPolicy() {
  return (
    <div className="home-container">
      <Navbar showSignUpButton={true} />
      <div className="privacy-policy-section">
        <h1>Privacy Policy</h1>
        <div className="policy-content">
          <p>Last updated: April 25, 2025</p>
          
          <h2>Introduction</h2>
          <p>
            Casalytix ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services to appeal property tax assessments. Please read this policy carefully. If you do not agree with the terms, please do not use our services.
          </p>

          <h2>Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul>
            <li><strong>Personal Information</strong>: Name, email address, billing information, and property address provided during account creation or service use.</li>
            <li><strong>Property Data</strong>: Information about your property, such as square footage, bedrooms, and comparable sales data, to generate appeal reports.</li>
            <li><strong>Usage Data</strong>: Information about how you interact with our website, including IP address, browser type, pages visited, and timestamps.</li>
            <li><strong>Cookies and Tracking</strong>: We use cookies to enhance your experience, analyze site usage, and personalize content. You can manage cookie preferences via your browser settings.</li>
          </ul>

          <h2>How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and improve our services, such as generating property valuation reports and appeal documents.</li>
            <li>Process payments and communicate with you about your account or services.</li>
            <li>Analyze usage trends to enhance our website and user experience.</li>
            <li>Comply with legal obligations and protect our rights.</li>
          </ul>

          <h2>Sharing Your Information</h2>
          <p>We do not sell your personal information. We may share information with:</p>
          <ul>
            <li><strong>Service Providers</strong>: Third-party vendors (e.g., payment processors, data providers like Real Estate API) who assist in delivering our services.</li>
            <li><strong>Legal Authorities</strong>: If required by law or to protect our rights and users.</li>
          </ul>

          <h2>Data Security</h2>
          <p>
            We implement reasonable security measures to protect your information. However, no system is completely secure, and we cannot guarantee absolute security.
          </p>

          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access, update, or delete your personal information by contacting us.</li>
            <li>Opt out of non-essential cookies or marketing communications.</li>
            <li>Request information about how your data is used or shared.</li>
          </ul>

          <h2>Third-Party Links</h2>
          <p>
            Our website may contain links to third-party sites (e.g., tax authority websites). We are not responsible for their privacy practices.
          </p>

          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy periodically. Changes will be posted on this page with an updated "Last updated" date.
          </p>

          <h2>Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, contact us at:
            <br />
            Email: casalytix@gmail.com
          </p>
        </div>
      </div>
      <footer className="footer">
        <p>
          © 2025 Casalytix. All rights reserved. | <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
        </p>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;